import { AlertTriangle } from "lucide-react";

export interface CheckInAllowance {
  limits: {
    checkInsPerMonth: number | null;
    overagePerCheckIn: number | null;
  };
  usage: {
    checkInsThisMonth: number;
    overageCheckIns: number;
    estimatedOverageCharge: number;
  };
}

interface OverAllowanceWarningProps {
  allowance: CheckInAllowance | null;
  className?: string;
}

export function OverAllowanceWarning({ allowance, className = "" }: OverAllowanceWarningProps) {
  if (allowance == null || allowance.limits.checkInsPerMonth === null) {
    return null;
  }

  const checkInLimit = allowance.limits.checkInsPerMonth;
  if (allowance.usage.checkInsThisMonth <= checkInLimit) return null;

  return (
    <div
      className={`flex items-start gap-2 text-sm text-red-700 bg-red-50 border border-red-100 rounded-lg px-3 py-2 ${className}`}
      role="alert"
    >
      <AlertTriangle size={16} className="shrink-0 mt-0.5" />
      {allowance.limits.overagePerCheckIn === null ? (
        <span>
          You're over your monthly check-in allowance. Visitor check-ins are never blocked. Upgrade to keep
          growing.
        </span>
      ) : (
        <span>
          {allowance.usage.overageCheckIns.toLocaleString()} check-in
          {allowance.usage.overageCheckIns === 1 ? "" : "s"} beyond your allowance at S$
          {allowance.limits.overagePerCheckIn.toFixed(2)} each — never blocked. Estimated current charge: S$
          {allowance.usage.estimatedOverageCharge.toFixed(2)}.
        </span>
      )}
    </div>
  );
}
